import rest from '@modules/rest'
import { PERSONAL_AREA } from '@convenia/common-organisms/SystemFields/content/consts'
import { mapCustomFields, mapSystemFields } from '@convenia/employee-organisms/SystemFields/Personal/content/mappers'
import { getUploadEndpoint, getFileUrl } from '@modules/fileHelpers'
import { mapBankAccount, mapBankAccountInput } from '@convenia/employee-organisms/SystemFields/Personal/content/mappers/bankAccounts'
import upload from '@modules/upload'

export const getBankAccount = async (params) => {
  try {
    const { employeeId, companyId } = params
    const url = `/employees/proxy/companies/${companyId}/employees/${employeeId}/bank-accounts/admission`
    const { data = [] } = await rest.get(url)

    const bankAccounts = data.map(({ customFieldValues, ...bankAccount }) => ({
      ...mapBankAccount(bankAccount, { employeeId, getFileUrl }),
      customFieldValues,
    }))

    return [ null, bankAccounts ]
  } catch (err) {
    return [ err, null ]
  }
}

export const createBankAccount = async (data, params) => {
  try {
    const { employeeId, companyId, schema } = params
    const url = `/employees/proxy/companies/${companyId}/employees/${employeeId}/bank-accounts/admission`
    const body = mapBankAccountInput({ data, schema })

    const response = await rest.post(url, { body, headers: { bcv: true } })

    const bankAccount = mapBankAccount(response?.data, { employeeId, getFileUrl })

    return [ null, bankAccount ]
  } catch (err) {
    return [ err, null ]
  }
}

export const updateBankAccount = async (data, params) => {
  try {
    const bankAccountId = data?.id
    const { employeeId, companyId, schema } = params
    const url = `/employees/proxy/companies/${companyId}/employees/${employeeId}/bank-accounts/${bankAccountId}/admission`
    const body = mapBankAccountInput({ data, schema })

    await rest.put(url, { body, headers: { bcv: true } })

    return [ null, true ]
  } catch (err) {
    return [ err, null ]
  }
}

export const deleteBankAccount = async (data, params) => {
  try {
    const bankAccountId = data?.id

    if (typeof bankAccountId !== 'string')
      return [ null, null ]

    const { employeeId, companyId } = params
    const url = `/employees/proxy/companies/${companyId}/employees/${employeeId}/bank-accounts/${bankAccountId}/admission`

    await rest.delete(url)

    return [ null, null ]
  } catch (err) {
    return [ err, null ]
  }
}

export const uploadBankAccountFiles = async ({ id, files, employeeId }) => {
  try {
    const endpoint = getUploadEndpoint(employeeId, id, 'bank_account')

    const data = await upload({ files, endpoint })

    return [ null, data || [] ]
  } catch (err) {
    return [ err, null ]
  }
}

export const getSystemFields = async ({ employeeId, companyId }) => {
  const url = `/companies/proxy/companies/${companyId}/employees/${employeeId}/fields/admission`

  try {
    const { data } = await rest.get(url, { params: { area: PERSONAL_AREA.LABEL } })
    const fields = data?.sections || []

    const systemFields = mapSystemFields(fields)
    const customFields = mapCustomFields(fields)

    return [ null, { systemFields, customFields } ]
  } catch (err) {
    return [ err, null ]
  }
}
